import { Link, type LinkProps } from '@mui/material';
import { type ReactNode } from 'react';
import { Link as ReactRouterLink, type LinkProps as ReactRouterLinkProps } from 'react-router-dom';

export interface InternalLinkProps extends Pick<
  LinkProps,
  'onClick' | 'sx' | 'underline' | 'color' | 'tabIndex'
> {
  children: ReactNode;
  to: ReactRouterLinkProps['to'];
}

export function InternalLink(props: InternalLinkProps) {
  return <Link component={ReactRouterLink} {...props} />;
}
